import {v4 as uuidv4} from 'uuid';
import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {MoreVo} from '../../common/shared/api/karina/vo/MoreVo.interface';
import {ItemType, MoreItem} from '../generated/types';

export function createMoreItem(
  {scheme, text}: MoreVo,
  viewType: ViewTypeVo
): MoreItem {
  return {
    id: uuidv4(),
    type: ItemType.More,
    scheme,
    title: text,
    // 기본적으로 More는 카드뷰 형태라서 포스터뷰는 별도 처리를 해 주어야 한다. 그래서 posterview의 더보기임을 구별할 수 있도록 내려주는 값
    isPosterView:
      viewType === ViewTypeVo.SeriesPosterView ||
      viewType === ViewTypeVo.SinglePosterView,
  };
}
